import * as React from "react";

import { nullElement } from "../../TypingUtils";

export interface VisibilityBlockProps {
    children: JSX.Element;
    visible: boolean;
}

export function VisibilityBlock(props: VisibilityBlockProps): null | JSX.Element {
    return props.visible ? <>props.children</> : nullElement;
}
